import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/layout/Layout";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import CaseStudies from "@/pages/CaseStudies";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import HowItWorks from "@/pages/HowItWorks";
import WhatWeDo from "@/pages/WhatWeDo";
import Pricing from "@/pages/Pricing";
import GrowthOS from "@/pages/GrowthOS";
import Trust from "@/pages/Trust";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import Disclosures from "@/pages/legal/Disclosures";
import NotFound from "@/pages/NotFound";

// Stable reference to avoid Toaster re-renders on every App render.
const TOAST_OPTIONS = {
  style: {
    background: "#0d0d0d",
    color: "#ffffff",
    border: "1px solid rgba(212,175,55,0.25)",
    borderRadius: 0,
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/growth-system" element={<Services />} />
            <Route path="/services" element={<Services />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/growth-os" element={<GrowthOS />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/trust" element={<Trust />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/legal/privacy" element={<Privacy />} />
            <Route path="/legal/terms" element={<Terms />} />
            <Route path="/legal/disclosures" element={<Disclosures />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={TOAST_OPTIONS}
      />
    </div>
  );
}

export default App;
